import { makeStyles } from '@material-ui/core/styles';
import { indigo, blue } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    marginBottom: theme.spacing(4)
  },
  tabPanel: {
    'paddingTop': 20,
    '&>div': {
      padding: 0,
    },
  },
  card: {
    marginBottom: theme.spacing(6)
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  formItem: {
    paddingTop: 20,
    fontWeight: 500,
  },
  chipInput : {
    background: '#FFFFFF'
  },
  checkboxText: {
    fontSize:14,
    fontWeight: 'normal',
    color:'#626C82'
  }
}));

export default useStyles;
